import '@splidejs/splide/css';

import '../css/styles.css';
import '../less/slider.less';

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import './certifications.js';

var mainSlider = document.getElementById('mainSlider');
if (mainSlider) {
    new Splide(mainSlider, {
        type: 'loop',
        autoplay: true
    }).mount();
}

var clientSlider = document.getElementById('clientsSlider');
if (clientSlider) {
    new Splide(clientSlider, {
        type: 'loop',
        drag   : 'free',
        focus  : 'center',
        perPage: 5,
        autoScroll: {
            speed: 1
        },
        pagination: false
    }).mount({ AutoScroll });
}

let searchInput = document.getElementById('searchInput');
if (searchInput) {
    searchInput.addEventListener('keyup', e => {
        if (event.key === "Enter") {
            let value = e.target.value;
            if (value) {
                let search = new URLSearchParams();
                search.append('q', value);
                window.location.href = (new URL(`/search/?${search.toString()}`, window.location.origin)).toString();
            }
        }

    });
}

let forms = document.querySelectorAll("form");

for (let form of Array.from(forms)) {

    form.addEventListener("submit", (e) => postForm(e, form));
}

function postForm(submitEvent, form) {
    submitEvent.preventDefault();
    let message = document.getElementById('response-output');

    let submitButton = submitEvent.target.querySelector('input[type=submit]');

    submitButton.disabled = true;

    var formData = new FormData(form);
    formData.append("_url", window.location.href);

    fetch(submitEvent.target.action, {
        method: "post",
        body: formData
    }).then(response => {
        if (response.ok) {
            form.reset();
            submitButton.disabled = false;
            message.innerHTML =
                "<strong>Success!</strong> Your message was successfully sent.";
            message.classList.remove('error');
            message.classList.add('success');
        } else {
            submitButton.disabled = false;
            message.innerHTML = "<strong>Error submitting, please contact us directly by email at support&#64;methodandstyle&#46;com.</strong>";
            message.classList.add('error');
            message.classList.remove('success');
        }
    });

}
